// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"235":"1da108d2","688":"1da108d2"}[chunkId] + ".chunk.css";
};